import { beautifyPlanName } from '@localstack/services';
import { PlanFamily, FeatureMaturityLevel, PlanChipProps } from '@localstack/types';
import { Chip, Link, Tooltip } from '@mui/material';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { ReactElement } from 'react';

import { ExternalLink } from '@localstack/constants';

import { WrapInComponent } from '../../utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    planChip: {
      marginLeft: theme.spacing(2),
    },
  }),
);

const tooltipText = {
  [PlanFamily.FREEMIUM_PLANS]: 'Available in the LocalStack Hobby plan',
  [PlanFamily.BASE_PLANS]: 'Available in the LocalStack for AWS Base plan',
  [PlanFamily.ULTIMATE_PLANS]: 'Available in the LocalStack for AWS Ultimate plan',
  [PlanFamily.ENTERPRISE_PLANS]: 'Available in the LocalStack Enterprise plans',
  [FeatureMaturityLevel.PREVIEW]: ExternalLink.DOCS_FEATURES_UNDER_DEVELOPMENT,
  [FeatureMaturityLevel.EXPERIMENTAL]: ExternalLink.DOCS_FEATURES_UNDER_DEVELOPMENT,
} as const;

export const PlanChip = ({
  planFamily,
  size = 'small',
  showTooltip,
  tooltipTitleOverride,
  withStyles = true,
  ...rest
}: PlanChipProps): ReactElement => {
  const classes = useStyles();
  const finalText = tooltipTitleOverride || (tooltipText[planFamily as keyof typeof tooltipText] ?? '');

  return (
    <WrapInComponent
      wrap={showTooltip}
      wrapperFn={(child) =>
        finalText.startsWith('http') ? (
          <Link target="_blank" href={finalText} underline="hover" onClick={(event) => event.stopPropagation()}>
            {child}
          </Link>
        ) : (
          <Tooltip title={finalText}>{child}</Tooltip>
        )
      }
    >
      <Chip
        variant="outlined"
        size={size}
        label={beautifyPlanName(planFamily)}
        color="primary"
        className={withStyles ? classes.planChip : undefined}
        {...rest}
      />
    </WrapInComponent>
  );
};

export default PlanChip;
